import { trackEvent } from 'utils/analytics';

export const getInitialState = () => ({
	primaryFocus: {
		title: 'Show programs and organizations who focus on:',
		options: [
			{
				name: 'Clean energy transition',
				id: 'Accelerating the clean energy transition'
			},
			{ name: 'Empowering women', id: 'Empowering women' },
			{ name: 'Energy poverty', id: 'Addressing energy poverty' },
			{
				name: 'Gender equality and social inclusion',
				id: 'Promoting gender equality and social inclusion'
			},
			{
				name: 'Moving capital into clean energy and climate change',
				id: 'Moving Capital into Clean Energy/Climate Change'
			}
		],
		selected: null
	}
});

export const actions = {
	updateFilter: (state, id, selected) => {
		trackEvent(`Filter ${id}`, 'Update', selected);
		return {
			...state,
			[id]: { ...state[id], selected }
		};
	},
	clearFilter: (state, id) => {
		trackEvent(`Filter ${id}`, 'Update', 'Default');
		return {
			...state,
			[id]: { ...state[id], selected: null }
		};
	}
};

export default {
	getInitialState,
	actions
};



// WEBPACK FOOTER //
// ./state/filters.js